export class BaseSEOOutputDTO {
    metaTitle: string;
    metaDescription: string;
    metaKeywords: string;

    constructor() {
        this.metaTitle = "";
        this.metaDescription = "";
        this.metaKeywords = "";
    }
}